import React from 'react';

import { ICourse } from '../../../../types';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../Summary/SummaryGroup';
import { SummaryRow } from '../../../Summary/SummaryRow';

interface Props {
  showRisks: boolean;
  courses?: Array<ICourse>;
  riskList?: string[];
}

function CourseOfferEvidence({ courses: allCourses }: Props) {
  const courses = allCourses?.filter(course => course && course.courseName !== undefined && course.courseName !== '');

  return (
    <>
      {courses !== undefined && (
        <>
          <SummaryGroup title="Evidence Used to Obtain Offer">
            <Box as="ol" pl={8}>
              {courses.map((course: ICourse, index: number) => {
                return (
                  <React.Fragment key={`course-${index}`}>
                    <SummaryRow label="Course" value={course.courseName} />

                    {course.offerEvidence && (
                      <SummaryRow label="Evidence Used for Offer" value={course.offerEvidence} />
                    )}
                  </React.Fragment>
                );
              })}
            </Box>
          </SummaryGroup>
        </>
      )}
    </>
  );
}

export default CourseOfferEvidence;
